import {getApiRequestBuilder, putApiRequestBuilder} from "@/utils/RequestBuilder";

export function getNotificationPatterns() {
	return getApiRequestBuilder(`notification-patterns`).send();
}

export function updateNotificationPattern(pattern) {
	return putApiRequestBuilder(`notification-patterns`).send(pattern);
}
